export default "__VITE_ASSET__DojKqimd__"